<!-- components/EditForm.vue -->
<template>
    <div class="edit-form">
        <div class="tou_div">
            <div class="touxiang_div">
                <div class="userNameText">{{ userName.split("")[0] }}</div>
            </div>
            <div>
                <div>{{ userName }}</div>
                <div>{{ department }}</div>
                <div>{{ position }}</div>
            </div>
        </div>
        <div class="bor_div">
            <div>会员：</div>
            <div class="ordinary_div" id="vipIdentification_div">{{ vipIdentification }}</div>
            <div class="vipin_div">{{ vipEndTime }}</div>
        </div>
        <div class="bor_div">
            <div>积分：</div>
            <div>{{ integral }}</div>
            <el-button type="primary" @click="RedeemVIP" class="RedeemVIP_button">兑换VIP</el-button>
        </div>
        <div class="button_div" v-show="obtainSate">
            <el-button type="primary" @click="changeUsername" class="button_b">修改用户名</el-button>
            <el-button type="primary" @click="ChangePassword" class="button_b">修改密码</el-button>
            <el-button type="warning" @click="ModifyEmail" class="button_b">修改邮箱</el-button>
            <el-button type="danger" @click="DeleteAccount" class="button_b">注销账号</el-button>
        </div>
    </div>
    <ModalEI v-if="showModal" v-model:visible="showModal" v-model:titleValue="titleValueGroup"
        @close="showModal = false">
        <ModifyUserIntroduce @close="showModal = false" :types="types_tp" />
    </ModalEI>
</template>

<script>
import request from '@/utils/request' // 就写这一行

export default {
    name: 'UserIntroduce',
    props: [],
    data() {
        return {
            integral: 0,
            userName: "",
            position: "",
            vipIdentification: "普通用户", // [普通用户,vip, svip]
            vipEndTime: "",
            department: "",
            obtainSate: false,
            showModal: false,
            titleValueGroup: "",
            types_tp: ""
        }
    },
    methods: {
        changeUsername() {
            // console.log("修改用户名");
            this.titleValueGroup = "修改用户名";
            this.showModal = true;
            this.types_tp = "as";
        },
        ChangePassword() {
            // console.log("修改密码");
            this.titleValueGroup = "修改密码";
            this.showModal = true;
            this.types_tp = "pa";
        },
        ModifyEmail() {
            // console.log("修改邮箱");
            this.titleValueGroup = "修改邮箱";
            this.showModal = true;
            this.types_tp = "em";
        },
        async DeleteAccount() {
            // console.log("注销账号");
            var a = confirm("确定要将账号注销吗？【提示：账号注销后将删除所有有关账号内的信息和数据！且无法恢复！请慎重操作！】");
            if (a) {
                try {
                    const res = await request.post('/DeleteAccount', {});
                    this.$messageX.xiaoxiti("c", res.message);
                    localStorage.clear();
                    location.reload();

                } catch (err) {
                    console.log('失败:', err)
                    if (err.response.data.message) {
                        this.$messageX.xiaoxiti("e", err.response.data.message);
                    } else {
                        this.initData();
                        this.$messageX.xiaoxiti("e", err.message);
                    }
                }
            }
        },
        RedeemVIP() {
            console.log("兑换VIP");
            confirm("敬请期待！");
        },
        async obtainData() {
            try {
                const res = await request.post('/AgainRefresh', {});
                // this.$messageX.xiaoxiti("c", res.message);
                this.integral = res.response.user.Integral;
                this.userName = res.response.user.Accounts;
                this.position = res.response.user.Position;
                this.department = res.response.user.Department;
                if (res.response.user.IsVIP == 1) {
                    this.vipIdentification = "VIP";
                    document.getElementById("vipIdentification_div").classList.add("vip_div");
                    this.vipEndTime = this.$messageX.formatGmtToLocal(res.response.user.EndTimeVIP, '%Y年%m月%d日到期');
                } else if (res.response.user.IsVIP == 2) {
                    this.vipIdentification = "SVIP";
                    document.getElementById("vipIdentification_div").classList.add("svip_div");
                    this.vipEndTime = this.$messageX.formatGmtToLocal(res.response.user.EndTimeVIP, '%Y年%m月%d日到期');
                } else {
                    this.vipIdentification = "普通用户";
                    document.getElementById("vipIdentification_div").className = "ordinary_div";
                }
                this.obtainSate = true;
            } catch (err) {
                console.log('失败:', err)
                if (err.response.data.message) {
                    this.$messageX.xiaoxiti("e", err.response.data.message);
                } else {
                    this.initData();
                    this.$messageX.xiaoxiti("e", err.message);
                }
            }
        }
    },
    mounted() {
        var width = window.innerWidth;
        if (width > 300) {
            width = 300;
        }
        document.getElementsByClassName("edit-form")[0].style.width = width + "px";
        this.obtainData();
    },
    beforeUnmount() {

    },
    watch: {

    },
}
</script>

<style scoped>
.edit-form {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
}

.touxiang_div {
    border-radius: 100%;
    background-color: rgb(0, 149, 248);
    height: 50px;
    width: 50px;
    margin-right: 10px;
    border: 2px solid #0150d8;
    display: flex;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
}

.userNameText {
    color: rgba(255, 255, 255, 1);
}

.tou_div {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-bottom: 10px;
}

.button_div {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.bor_div {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-bottom: 10px;
}

.ordinary_div {
    color: rgb(86 86 86);
}

.vip_div {
    color: rgb(244, 241, 64);
    font-weight: 600;
}

.svip_div {
    color: rgb(255, 200, 0);
    font-weight: 800;
}

.vipin_div {
    padding-left: 5px;
}

.RedeemVIP_button {
    margin-left: 15px;
}

.button_b {
    width: 100%;
    margin-bottom: 15px;
    padding-left: 0;
    margin-left: 0;
    border-radius: 5px;
}
</style>